export default "on Pagination {\n  total\n}\n";